import { Directive, HostListener } from '@angular/core';

@Directive({ selector: 'input[type=number]', standalone: false })
export class NoScrollOnNumberInputDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    (event.target as HTMLElement).blur();
  }
}
